import React, { useMemo } from "react"

import PrestamosButtons from "#colaborador/Solicitudes/prestamos_componentes/PrestamosButtons"
import { formatMoney } from "#common/Funciones"
import { SkeletonSquare } from "#common/Skeleton"
import PERMISOS from "#constants/perfiles"
import { capitalizeSpanish } from "#core/functions/string"
import ErrorResponse from "#core/pages/ErrorResponse"
import { useApi } from "#hooks/useApi"
import { useLoanRedux } from "#loan/redux/slice"
import { loanGet } from "#loan/services/api"
import { Box } from "@mui/material"
import MUIDataTable from "mui-datatables"

export function LoanTableColaborador({ colaborador, autoFetch = true }) {
	const { reload } = useLoanRedux()
	const params = useMemo(() => ({ all: true, my_loans: colaborador }), [])
	const { data, loading, error } = useApi(loanGet, { autoFetch, params, reload })
	const loans = useMemo(() => data?.data || [], [data])

	const dateView = (value) => {
		if (value === null) return "N/A"
		return value
	}
	let columns = [
		{
			name: "turno",
			label: "Turno",
			options: {
				filter: false,
				display: true,
			},
		},

		{
			name: "status_descripcion",
			label: "Estado",
			options: {
				filter: false,
				display: true,
			},
		},
		{
			name: "metodo_pago_descripcion",
			label: "Método De Pago",
			options: {
				filter: false,
				display: true,
			},
		},
		{
			name: "cantidad",
			label: "Cantidad",
			options: {
				filter: false,
				display: true,
				customBodyRender: (value, tableMeta) => {
					const loan = loans[tableMeta.rowIndex]
					return formatMoney(value, loan.currency)
				},
			},
		},

		{
			name: "autorizador_nombre",
			label: "Jefe Autorizado",
			options: {
				filter: false,
				display: true,
			},
		},
		//Fechas
		{
			name: "fecha_solicitud",
			label: "Fecha Solicitud",
			options: {
				filter: false,
				display: true,
			},
		},
		{
			name: "fecha_pago",
			label: "Fecha de pago",
			options: {
				filter: false,
				display: true,
				customBodyRender: dateView,
			},
		},
		{
			name: "action", // Nombre de la columna para el botón
			label: " ", // Título de la columna
			options: {
				filter: false,
				sort: false,
				display: true,
				customBodyRender: (value, tableMeta) => {
					let loan = loans[tableMeta.rowIndex]

					return (
						<React.Fragment>
							<PrestamosButtons
								data={loan}
								ID={loan["id"]}
								user={PERMISOS.COLABORADOR}
								filtro={{ status: null }}
							/>
						</React.Fragment>
					)
				},
			},
		},
	]

	const options = {
		textLabels: {
			body: {
				noMatch: "No hay solicitudes",
			},
		},
		rowsPerPage: 100,
		search: false,
		filter: false,
		download: false,
		print: false,
		viewColumns: false,
		selectableRows: "none",
	}

	if (loading) return <SkeletonSquare />
	if (error) return <ErrorResponse api={error} />
	columns = columns.map((col) => {
		return { ...col, label: capitalizeSpanish(col.label) }
	})
	return (
		<Box width={"100%"}>
			<MUIDataTable title={""} data={data?.data} columns={columns} options={options} />
		</Box>
	)
}
